<section appFadeIn class="section-dark" id="juno">
  <div class="container">
    <div class="hero">
      <h1 style="margin-top: 10px; font-size: 3rem; text-align: center;">
        Juno Audit™ – <span>platforma do audytów</span>, kontroli i jakości
      </h1>
      <p style="text-align: center; font-size: 1.5rem; margin: 40px auto 60px auto; max-width: 800px;">
        Działa na telefonie, nie wymaga instalacji, oszczędza czas i daje Ci pełen wgląd w jakość – w każdym miejscu i o
        każdej porze.
      </p>
      <p style="text-align: center;">
        Zlecasz audyty, kontrolujesz jakość lub zarządzasz siecią placówek?
      </p>
      <p>Juno Audit łączy wszystko w jednym miejscu: audytorów z firmami, checklisty z raportami, dane z konkretnymi
        działaniami naprawczymi.</p>

      <div class="juno-buttons">
        <a href="#" (click)="scrollTo('example', $event)" class="juno-button">
          <i class="fa-solid fa-file-lines"></i> Zobacz przykładowy raport
        </a>
        <a href="#" (click)="scrollTo('JoinUs', $event)" class="juno-button">
          <i class="fa-solid fa-comments"></i> Porozmawiaj z nami
        </a>
      </div>

      <div class="features">
        <span><i class="fas fa-robot fa-icon"></i> Powered by AI</span>
        <span><i class="fas fa-palette fa-icon"></i> Własny branding</span>
        <span><i class="fas fa-link fa-icon"></i> Audyt z linka</span>
        <span><i class="fas fa-list-check fa-icon"></i> Pełna kontrola jakości</span>
      </div>
    </div>
  </div>
</section>

<section appFadeIn class="section" id="how">
  <div class="container">
    <h2 style="text-align: center;">Jak to działa</h2>
    <hr />
    <p style="text-align: center; max-width: 700px; margin: 0 auto;">
      Juno Audit prowadzi Cię przez cały proces audytu: od stworzenia scenariusza, przez zebranie danych, aż po gotowy
      raport.
    </p>

    <div class="cards">
      <div appFadeIn class="card">
        <div class="card-header">
          <i class="fas fa-sliders card-icon"></i>
          <span><strong style="color: var(--color-link);">Ustal, co chcesz kontrolować</strong></span>
        </div>
        <p style="margin-top: 10px;">
          Zdefiniuj punkty kontroli, cele i osoby odpowiedzialne. Obsłuż różne lokalizacje i klientów w jednym systemie.
        </p>
      </div>

      <div appFadeIn class="card">
        <div class="card-header">
          <i class="fas fa-list-check card-icon"></i>
          <span><strong style="color: var(--color-link);">Zbuduj checklistę w kilka minut</strong></span>
        </div>
        <p style="margin-top: 10px;">
          Dodaj pytania, skale ocen, komentarze i wymagane zdjęcia. Zastosuj szablony lub stwórz własny audyt od zera.
        </p>
      </div>

      <div appFadeIn class="card">
        <div class="card-header">
          <i class="fas fa-chart-line card-icon"></i>
          <span><strong style="color: var(--color-link);">Juno Audit generuje wynik i raport</strong></span>
        </div>
        <p style="margin-top: 10px;">
          Audytor uzupełnia formularz, a Ty otrzymujesz gotowe podsumowanie, wynik i PDF z wnioskami – nawet w wersji
          AI.
        </p>
      </div>
    </div>
  </div>
</section>

<section appFadeIn class="section-dark" id="benefits">
  <div class="container">
    <img alt="Illustration" src="images/juno-illustration.png" style="flex: 1 1 350px; max-width: 100%; height: auto;" />
    <div>
      <h2>Zalety Juno Audit™</h2>
      <hr />
      <p style="max-width: 850px; margin: 0 auto;">
        Zamiast dziesiątek maili, plików Word i Excela – Juno Audit daje Ci jedno przejrzyste narzędzie.
        W kilka minut zbudujesz checklistę, przypiszesz zadanie z terminem i lokalizacją, a audytor zrealizuje je z
        poziomu telefonu – bez logowania i bez instalowania aplikacji.
      </p>
      <p style="margin-top: 20px;">
        Po zakończeniu audytu masz dostęp do pełnego raportu z wynikami, komentarzami i zdjęciami.
        Klient otrzymuje podgląd raportu w swoim panelu. Ty – jasny obraz sytuacji i możliwość szybkiej reakcji.
      </p>
      <h3>Co oferujemy:</h3>
      <ul class="features-list">
        <li><i class="fa-solid fa-calendar-check"></i> Przypisywanie zadań z terminem i lokalizacją</li>
        <li><i class="fa-solid fa-list-check"></i> Tworzenie własnych scenariuszy audytowych</li>
        <li><i class="fa-solid fa-mobile-screen-button"></i> Panel audytora – mobilny, bez instalacji</li>
        <li><i class="fa-solid fa-chart-simple"></i> Panel managera z podglądem statusów</li>
        <li><i class="fa-solid fa-magnifying-glass-chart"></i> Scoring + wykrywanie niezgodności</li>
        <li><i class="fa-solid fa-sitemap"></i> White-label dla wielu klientów</li>
        <li><i class="fa-solid fa-rotate-right"></i> Reaudyty i działania naprawcze</li>
        <li><i class="fa-solid fa-file-pdf"></i> Raporty PDF + AI podsumowania</li>
        <li><i class="fa-solid fa-users"></i> Panel B2B – dostęp klienta</li>
        <li><i class="fa-solid fa-table-columns"></i> Dashboardy i porównania</li>
      </ul>
    </div>
  </div>
</section>

<section appFadeIn class="section" id="partners">
  <div class="container" style="display: flex; flex-wrap: wrap; gap: 40px; align-items: center;">
    <div style="flex: 1 1 400px;">
      <h2>Dla kogo Juno Audit™</h2>
      <hr />
      <p>
        Juno Pilot™powstał z myślą o małych i średnich firmach, które chcą mieć pełną kontrolę nad jakością – bez
        zbędnego chaosu.
      </p>

      <h3>Dla firm audytorskich</h3>
      <p style="margin-top: 15px;">
        Koniec z chaosem i wysyłaniem odrębnych plików przez e-mail. W Juno Audit udostępniasz gotowe raporty
        bezpośrednio w panelu klienta – wygodnie, w jednolitym formacie PDF.
      </p>

      <h3>Dla firm zlecających kontrole</h3>
      <p style="margin-top: 15px;">
        Zleć audyt jednym kliknięciem, obserwuj postępy, analizuj wyniki i reaguj błyskawicznie. Bez potrzeby tworzenia
        własnego systemu.
      </p>

      <h3>Dla partnerów i sieci</h3>
      <p style="margin-top: 15px;">
        Masz wiele lokalizacji? Z Juno Audit sprawdzisz, czy standardy są przestrzegane. Porównasz dane, wyciągniesz
        wnioski i uruchomisz działania naprawcze.
      </p>
    </div>
    <div style="flex: 1 1 200px; text-align: center;">
      <img alt="" src="images/delivery.png" style="max-width: 100%; height: auto;" />
    </div>
  </div>

  <div class="container" style="margin-top: -80px;">
    <h3>Branże i obszary</h3>
    <hr />
    <ul class="industries-list">
      <li><i class="fa-solid fa-fire-extinguisher"></i> PPOŻ – Ochrona przeciwpożarowa, szkolenia i
        kontrole.</li>
      <li><i class="fa-solid fa-helmet-safety"></i> BHP – Bezpieczeństwo i higiena pracy, audyty zgodności.
      </li>
      <li><i class="fa-solid fa-user-secret"></i> Mystery Shopper – Tajemniczy klienci, raporty jakości
        obsługi.</li>
      <li><i class="fa-solid fa-utensils"></i> Gastronomia – Kontrola czystości i standardów kuchni.</li>
      <li><i class="fa-solid fa-store"></i> Retail – Audyty sklepów, standaryzacja ekspozycji.</li>
      <li><i class="fa-solid fa-industry"></i> Produkcja – Kontrola jakości procesów i produktów.</li>
      <li><i class="fa-solid fa-chart-simple"></i> Inne branże – wszędzie tam, gdzie liczą się dane
        z ankiet, obserwacje terenowe i feedback z pierwszej ręki.</li>
    </ul>
  </div>
</section>



<section appFadeIn class="section-dark" id="example">
  <div class="container">
    <img alt="" src="images/juno-talking.png" width="370" style="flex: 1 1 350px; max-width: 100%; height: auto;" />
    <div>
      <h2><i class="fas fa-file-alt"></i> Raport generowany automatycznie po audycie</h2>
      <p>
        Po zakończeniu audytu Juno Audit automatycznie generuje szczegółowy raport zawierający: kompletną checklistę,
        komentarze i zdjęcia, wynik punktowy oraz podsumowanie ankiet od wszystkich audytorów.
      </p>
      <p>
        W Juno Audit audytor wypełnia raport bezpośrednio w systemie – w przejrzystym formularzu odpowiadającym
        końcowemu układowi dokumentu.
        Dzięki temu zachowujemy pełną spójność danych, ułatwiamy redakcję uwag i eliminujemy ryzyko błędów przy
        kopiowaniu treści między plikami.
        Gotowy raport generowany jest automatycznie jako estetyczny PDF i trafia bezpośrednio do panelu klienta.
      </p>

      <h3><i class="fas fa-layer-group"></i> Gotowe szablony i elastyczność tam, gdzie trzeba</h3>
      <p>
        Juno Audit oferuje zestaw sprawdzonych, <strong>standardowych szablonów raportów</strong>, które można od razu
        wdrożyć w większości branż.
      </p>
      <p>
        Dla firm o bardziej specyficznych wymaganiach opracowujemy <strong>dedykowane szablony</strong> – wspólnie z
        klientem, z uwzględnieniem:specyfiki branży i rodzaju audytu, wymogów wewnętrznych lub klienta końcowego,języka
        i struktury dokumentu zgodnych z polityką firmy
      </p>
      <p>
        Raporty mogą zawierać w pełni <strong>spersonalizowane sekcje</strong>, umożliwiające edycję: treści wstępnych i
        końcowych, opisu metodologii, komentarzy eksperckich, dodatkowych materiałów (np. instrukcji, zdjęć,
        załączników). 
      </p>
      <h3>
        <a href="files/przykladowy_raport_junopilot.pdf" download target="_blank"
          style="font-weight: bold; text-decoration: none;">
          <i class="fas fa-download"></i> Zobacz przykładowy raport (PDF)
        </a>
      </h3>
      <p>
        <a href="#" (click)="scrollTo('JoinUs', $event)"
          style="color: var(--color-link); font-weight: bold; text-decoration: none;">
          Skontaktuj się z nami
        </a>, aby omówić, jak Juno Audit może zostać dostosowany do Twoich potrzeb.
      </p>


    </div>
  </div>
</section>


<app-contact-modal></app-contact-modal>